import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { post } from "../parsedApi";

const workerCancelAlertBodySchema = z.object({
  shiftId: z.string().optional(),
  workerId: z.string(),
  facilityId: z.string().optional(),
  shouldReplaceWorker: z.boolean(),
});

export interface WorkerCancelAlertPayload {
  shiftId?: string;
  workerId: string;
  facilityId?: string;
  shouldReplaceWorker: boolean;
}

export function useSendWorkerCancelAlert() {
  return useMutation({
    mutationFn: async (payload: WorkerCancelAlertPayload) => {
      const { shiftId, workerId, facilityId, shouldReplaceWorker } = payload;

      await post({
        url: "/shifts/worker-cancel-request",
        data: {
          shiftId: shiftId ?? "N/A (from chat)",
          workerId,
          facilityId,
          shouldReplaceWorker,
        },
        bodySchema: workerCancelAlertBodySchema,
        responseSchema: z.unknown(),
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.SEND_WORKER_CANCEL_ALERT_FAILURE,
    },
  });
}
